import { UNINITIALIZED } from '../requestStates';
export default {
  requestState: UNINITIALIZED
};